import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useGetVideosQuery } from "../../redux/features/videos/videosAPI";
import { useAddAssignmentMutation } from "../../redux/features/assignments/assignmentAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import Error from "../../components/Error";
import usePageTitle from "../../utils/usePageTitle";

export default function AddAssignment() {
  usePageTitle("Add Assignment");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const {
    data: videos,
    isLoading: videoIsLoading,
    isError: videoIsError,
  } = useGetVideosQuery();

  const [addAssignment, { isLoading, error }] = useAddAssignmentMutation();

  const [title, setTitle] = useState("");
  const [video, setVideo] = useState({});
  const [totalMark, setTotalMark] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();
    addAssignment({
      title,
      totalMark,
      video_id: video.id,
      video_title: video.title,
    });

    navigate("/admin/assignments");
  };

  return (
    <section style={{ paddingTop: "5%" }}>
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-cyan">
            Add New Assignment
          </h2>
        </div>

        <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label
                htmlFor="video"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Associated Video
              </label>

              <select
                name="associatedVideo"
                required
                style={{
                  color: "white",
                  width: "100%",
                  backgroundColor: "rgb(30 41 59 / var(--tw-bg-opacity))",
                  height: "40px",
                  fontSize: "0.875rem",
                }}
                className="px-3 rounded-md mt-1"
                onChange={(e) =>
                  setVideo(
                    videos.find((video) => video.title === e.target.value)
                  )
                }
              >
                <option value="" hidden selected>
                  Select Associated Video
                </option>
                {!videoIsLoading &&
                  !videoIsError &&
                  videos.map((video) => (
                    <option key={video.id}>{video.title}</option>
                  ))}
              </select>
            </div>

            <br />
            <div>
              <label
                htmlFor="title"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray"
              >
                Title
              </label>
              <input
                id="title"
                name="title"
                type="name"
                autocomplete="name"
                required
                className="login-input rounded-md mt-1"
                placeholder="Assignment Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <br />

            <div>
              <label
                htmlFor="Marks"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Marks
              </label>
              <input
                id="marks"
                name="marks"
                type="number"
                autocomplete="marks"
                required
                className="login-input rounded-md mt-1"
                placeholder="Total Marks"
                onChange={(e) => setTotalMark(e.target.value)}
              />
            </div>
          </div>
          <div className="flex justify-end gap-x-2">
            <button
              type="submit"
              disabled={isLoading}
              className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Save
            </button>

            <Link
              to="/admin/assignments"
              type="submit"
              disabled={isLoading}
              className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Cancel
            </Link>
          </div>

          {error && <Error message={error.message} />}
        </form>
      </div>
    </section>
  );
}
